/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Service from '../service';
import { toast } from 'react-toastify';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import Pagination from 'components/Pagination';
import { useHistory } from 'react-router-dom';
import ModalConfirmation from '../../../components/Modal/ConfirmationModal';
import useVoiceChannels from 'hooks/useVoiceChannels';

import {
  Container,
  Row,
  Card,
  CardHeader,
  Button,
  Input,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';

import SimpleHeader from '../../../components/Headers/SimpleHeader';
import ReactLoader from 'components/Loader';

import {
  icon_column_style,
  individual_column_style,
  individual_icon_header_style,
  individual_header_style
} from '../../../assets/styles/table_custom_style';

const CallbackList = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [exitRoute, setExitRoute] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [idResource, setidResource] = useState();
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);

  const { options: voiceChannelOptions } = useVoiceChannels();

  useEffect(() => {
    handleGetResource();
  }, []);

  const handleGetResource = (selectedPage = 1, querySearch = '') => {
    Service.getAll(selectedPage, 10, false, querySearch)
      .then((res) => {
        const data = res.data.data;
        const newActivePage = selectedPage;
        const quantity = res.data.totalRegisters;

        setExitRoute(data);
        setQuantity(quantity);
        setActivePage(newActivePage);
        setLoading(false);
      })
      .catch(() => {
        toast.error('Não foi possível listar as Rotas de saída', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const handlePageChange = (activePage) => handleGetResource(activePage);

  const handleDelete = (id) => {
    Service.delete(id)
      .then(() => {
        toast.success('Rota de saída deletada com sucesso', {
          autoClose: 3000,
          closeOnClick: true
        });
        handleGetResource();
      })
      .catch(() => {
        toast.error('Ocorreu um erro!', {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .finally(() => {
        setOpenModalConfirmation(false);
        handleGetResource();
      });
  };

  const controlDelete = (id) => {
    setidResource(id);
    setOpenModalConfirmation(true);
  };

  const handleUpdate = (id) => {
    history.push(`exitRoute/form/${id}`);
  };

  const handleOnSearch = (event) => {
    const q = event.target.value;
    setTimeout(() => {
      handleGetResource(1, q);
    }, 500);
  };

  return (
    <>
      <SimpleHeader
        setCreate="/admin/exitRoute/form"
        name="Form validation"
        parentName="Forms"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Rotas de saída</h3>
                </CardHeader>

                <Row className="mt-3 mx-2">
                  <Col md="11">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Busca rota de saída"
                        type="text"
                        defaultValue=""
                        onChange={handleOnSearch}
                      />
                    </InputGroup>
                  </Col>
                </Row>

                <ToolkitProvider
                  data={exitRoute}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'route',
                      text: 'Rota',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'change_route',
                      text: 'Ajuste da rota',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'route_group_out.name',
                      text: 'Grupo de saída',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'voice_channel_id',
                      text: 'Canal de Voz',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      formatter: (cell) => {
                        const channel = voiceChannelOptions.find(
                          (opt) => opt.value === cell
                        );

                        return channel ? channel.label : cell || '-';
                      }
                    },
                    {
                      dataField: 'context.name',
                      text: 'Contexto',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      formatter: (_, row) => {
                        return (
                          <Button
                            size="sm"
                            color="info"
                            onClick={() => handleUpdate(row.id)}
                          >
                            <li className="fas fa-user-edit"></li>
                          </Button>
                        );
                      }
                    },

                    {
                      dataField: 'delete',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'deletar',
                      formatter: (_, row) => {
                        return (
                          <Button
                            size="sm"
                            color="danger"
                            onClick={() => controlDelete(row.id)}
                          >
                            <li className="fas fa-trash"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
      <ModalConfirmation
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={idResource}
        deleteResource={handleDelete}
        message={'Tem certeza que deseja excluir a rota de saída?'}
      />
    </>
  );
};

export default CallbackList;
